import type { TellescopeFormFieldBaseProps } from "../../types";
import { Session } from "@tellescope/sdk";
import { AppointmentBookingFieldContent } from "./AppointmentBookingFieldContent";

export interface AppointmentBookingFieldProps extends TellescopeFormFieldBaseProps<"Appointment Booking"> {
  session: Session;
  enduserId: string;
  userIds?: string[];
  portalURL?: string;
  organizationSubdomain?: string;
}

export const AppointmentBookingField = ({ title, ...rest }: AppointmentBookingFieldProps) => {
  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <AppointmentBookingFieldContent {...rest} />
    </div>
  );
};
